import React, { ComponentType, ReactNode, useState } from 'react';
import { fmtGalleryImages, fmtSelectedImage, openModal } from '../helpers/gallery';

type ObjectType = {
  [key: string]: string;
};

interface WithGalleryProps {
  children: ReactNode;
  quantity: number;
  product: ObjectType;
  history: ObjectType;
  currentSku: {
    images?: string[];
    diffs?: {
      type: string;
    }[];
  };
}

export const withGallery = (Component: ComponentType) => (props: WithGalleryProps) => {
  const { quantity = 0, product = {}, currentSku = {} } = props;
  const { images: productImages, name, video } = product;
  const types = ['Cor', 'Sabor', 'Tamanho', 'Size'];
  const diffs = currentSku?.diffs ?? [];
  const useSkuImages = diffs.some(({ type }: { type: string }) => types.includes(type));
  const images = useSkuImages && currentSku?.images ? currentSku?.images : productImages;
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const galleryImages = fmtGalleryImages(images as any[], video, quantity, selectedImageIndex);
  const selectedImage = fmtSelectedImage(galleryImages, selectedImageIndex);
  const hasThumbs = galleryImages?.length > 1;

  const componentProps = {
    galleryImageProps: {
      name,
      images: galleryImages,
      selectedImage,
      setSelectedImageIndex,
      selectedImageIndex,
      modalImages: fmtGalleryImages(images as any[], video, 0, selectedImageIndex),
      openModal: openModal(props.history),
      hasThumbs,
    },
  };

  return <Component {...props} {...componentProps} />;
};

export default withGallery;
